import { Button, cn, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@newfront-insurance/core-ui/v2';
import type { ComponentProps } from 'react';

export type MessageActionsProps = ComponentProps<'div'>;

export function MessageActions({ className, children, ...props }: MessageActionsProps) {
  return (
    <div className={cn('flex items-center gap-1', className)} {...props}>
      {children}
    </div>
  );
}

export type MessageActionProps = ComponentProps<typeof Button> & {
  tooltip?: string;
  label?: string;
  isActive?: boolean;
};

export function MessageAction({
  tooltip,
  children,
  label,
  className,
  variant = 'transparent',
  size = 'small',
  isActive = false,
  ...props
}: MessageActionProps) {
  const button = (
    <Button
      className={cn('text-muted-foreground hover:text-foreground relative size-8 p-1.5', className)}
      size={size}
      type="button"
      variant={variant}
      {...props}
    >
      <div
        className={cn('rounded p-0.5', {
          'text-steel-700': isActive,
        })}
      >
        {children}
      </div>
      <span className="sr-only">{label || tooltip}</span>
    </Button>
  );

  if (tooltip) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>{button}</TooltipTrigger>
          <TooltipContent side="bottom">
            <p>{tooltip}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return button;
}
